import { IsNullOrUndefinedPipe } from '@adaptiva/core/common';
import { DisplayAuthoringPropertyPipe, InheritPipe, IsRequiredPropertyPipe, SerializedPropertyMapPipe } from '@adaptiva/metadata/common';
import { CardComponentModule } from '@adaptiva/widgets/card';
import { ContainerComponentModule } from '@adaptiva/widgets/container';
import { ExpressionLanguageEditorModule } from '@adaptiva/widgets/expression-editor';
import { InputComponentModule } from '@adaptiva/widgets/input';
import { ListBuilderComponentModule } from '@adaptiva/widgets/list-builder';
import { TextComponentModule } from '@adaptiva/widgets/text';
import { CommonModule } from '@angular/common';
import { NgModule, PipeTransform, Type } from '@angular/core';
import { AuthoringPropertyLabelComponentModule } from '../authoring-property-label-component';
import { AuthoringRuleComponentModule } from '../authoring-rule';
import { RulesPropertiesComponent } from './rules-properties.component';

const WIDGETS: Type<any>[] = [
	AuthoringPropertyLabelComponentModule,
	AuthoringRuleComponentModule,
	CardComponentModule,
	ContainerComponentModule,
	ExpressionLanguageEditorModule,
	InputComponentModule,
	IsNullOrUndefinedPipe,
	ListBuilderComponentModule,
	TextComponentModule,
];

const PIPES: Type<PipeTransform>[] = [
	DisplayAuthoringPropertyPipe,
	IsRequiredPropertyPipe,
	InheritPipe,
	SerializedPropertyMapPipe,
];

@NgModule({
	imports: [
		CommonModule,
		PIPES,
		WIDGETS
	],
	declarations: [RulesPropertiesComponent],
	exports: [RulesPropertiesComponent]
})
export class RulesPropertiesComponentModule {

}
